import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Custom error handler that detects chunk/module load failures
 * and auto-reloads the page once to recover from stale deployments.
 * Falls through to console.error for all other errors.
 */
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const chunkFailedMessage = /Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed|ChunkLoadError|is not a valid JavaScript MIME type|responded with a MIME type of/;

    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStack = error instanceof Error ? error.stack || '' : '';

    const isAngularDeferError =
      /ɵ(cmp|dir|pipe|mod|fac|inj)/.test(errorMessage) ||
      errorStack.includes('getComponentDef') ||
      errorStack.includes('getDirectiveDef') ||
      errorStack.includes('getPipeDef') ||
      errorStack.includes('getNgModuleDef') ||
      // Safari/iOS evaluation of minified Angular Ivy properties on undefined
      (((errorMessage.includes('evaluating') || errorMessage.includes('reading')) &&
        /\b(We|Aa|pd)\b/.test(errorStack) &&
        /allSettled/.test(errorStack)));

    if (chunkFailedMessage.test(errorMessage) || isAngularDeferError) {
      // Prevent infinite reload loop by checking sessionStorage
      const reloadKey = 'chunk_reload_attempted';
      const alreadyReloaded = typeof window !== 'undefined'
        && window.sessionStorage.getItem(reloadKey);

      if (!alreadyReloaded && typeof window !== 'undefined') {
        window.sessionStorage.setItem(reloadKey, 'true');
        window.location.reload();
        return;
      }

      // If already reloaded once, clear the flag and log the error
      window.sessionStorage.removeItem(reloadKey);
    }

    console.error(error);
  }
}
